<template>
    <v-text-field
      v-model="ordernumber"
      :counter="15"
      :label="displaytext"
      data-vv-name="ordernumber"
      clearable
      @click:clear="clear()"
      v-on:input="$emit('update', ordernumber)"
    ></v-text-field>
</template>

<script>
export default {
  props: [ 'displaytext' ],
  data () {
    return {
      ordernumber: ''
    }
  },
  methods: {
    clear () {
      this.ordernumber = null
    }
  }
}
</script>
